export default __webpack_public_path__ + "static/arete-5b0362f9509e2981f75ae5ddd28e652e.png";